import { render, staticRenderFns } from "./Histogramas.vue?vue&type=template&id=0d0898d6&scoped=true"
import script from "./Histogramas.vue?vue&type=script&lang=js"
export * from "./Histogramas.vue?vue&type=script&lang=js"
import style0 from "./Histogramas.vue?vue&type=style&index=0&id=0d0898d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0898d6",
  null
  
)

export default component.exports